import React from 'react';
import Icon from '../../../components/AppIcon';
import { Checkbox } from '../../../components/ui/Checkbox';
import ContactListItem from './ContactListItem';

const ContactList = ({ 
  contacts, 
  selectedContacts, 
  onContactSelect, 
  onContactCall, 
  onContactEdit,
  onBulkSelect,
  sortBy,
  onSortChange,
  isLoading = false 
}) => {
  const handleSelectAll = (checked) => {
    if (checked) {
      onBulkSelect(contacts?.map(contact => contact?.id));
    } else {
      onBulkSelect([]);
    }
  };

  const handleContactSelect = (contact) => {
    onContactSelect(contact);
  };

  const handleContactToggle = (contactId, checked) => {
    if (checked) {
      onBulkSelect([...selectedContacts, contactId]);
    } else {
      onBulkSelect(selectedContacts?.filter(id => id !== contactId));
    }
  };

  const getSortIcon = (field) => {
    if (sortBy?.field !== field) return 'ArrowUpDown';
    return sortBy?.direction === 'asc' ? 'ArrowUp' : 'ArrowDown';
  };

  const handleSort = (field) => {
    const direction = sortBy?.field === field && sortBy?.direction === 'asc' ? 'desc' : 'asc';
    onSortChange({ field, direction });
  };

  const isAllSelected = contacts?.length > 0 && selectedContacts?.length === contacts?.length;
  const isPartiallySelected = selectedContacts?.length > 0 && selectedContacts?.length < contacts?.length;

  if (isLoading) {
    return (
      <div className="flex-1 flex items-center justify-center">
        <div className="text-center">
          <Icon name="Loader2" size={32} className="animate-spin mx-auto mb-4 text-slate-400" />
          <p className="text-slate-600">Kişiler yükleniyor...</p>
        </div>
      </div>
    );
  }

  if (contacts?.length === 0) {
    return (
      <div className="flex-1 flex items-center justify-center">
        <div className="text-center">
          <Icon name="Users" size={48} className="mx-auto mb-4 text-slate-400" />
          <h3 className="text-lg font-medium text-slate-900 mb-2">Kişi bulunamadı</h3>
          <p className="text-slate-600 mb-4">Arama kriterlerinizi değiştirmeyi deneyin</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex-1 flex flex-col">
      {/* List Header */}
      <div className="bg-slate-50 border-b border-slate-200 p-4">
        <div className="flex items-center space-x-4">
          <Checkbox
            checked={isAllSelected}
            indeterminate={isPartiallySelected}
            onChange={(e) => handleSelectAll(e?.target?.checked)}
          />
          
          <div className="flex-1 grid grid-cols-12 gap-4 text-xs font-medium text-slate-600 uppercase tracking-wide">
            <button
              className="col-span-3 flex items-center space-x-1 hover:text-slate-900 text-left"
              onClick={() => handleSort('name')}
            >
              <span>Ad Soyad</span>
              <Icon name={getSortIcon('name')} size={14} />
            </button>
            
            <button
              className="col-span-2 flex items-center space-x-1 hover:text-slate-900 text-left"
              onClick={() => handleSort('phone')}
            >
              <span>Telefon</span>
              <Icon name={getSortIcon('phone')} size={14} />
            </button>
            
            <button
              className="col-span-2 flex items-center space-x-1 hover:text-slate-900 text-left"
              onClick={() => handleSort('company')}
            >
              <span>Şirket</span>
              <Icon name={getSortIcon('company')} size={14} />
            </button>
            
            <button
              className="col-span-2 flex items-center space-x-1 hover:text-slate-900 text-left"
              onClick={() => handleSort('lastContact')}
            >
              <span>Son İletişim</span>
              <Icon name={getSortIcon('lastContact')} size={14} />
            </button>
            
            <div className="col-span-1 text-center">Durum</div>
            <div className="col-span-2 text-center">İşlemler</div>
          </div>
        </div>
      </div>
      {/* Contact List */}
      <div className="flex-1 overflow-y-auto">
        <div className="p-4 space-y-2">
          {contacts?.map((contact) => (
            <div key={contact?.id} className="flex items-center space-x-4">
              <Checkbox
                checked={selectedContacts?.includes(contact?.id)}
                onChange={(e) => handleContactToggle(contact?.id, e?.target?.checked)}
              />
              
              <div className="flex-1">
                <ContactListItem
                  contact={contact}
                  isSelected={selectedContacts?.includes(contact?.id)}
                  onSelect={handleContactSelect}
                  onCall={onContactCall}
                  onEdit={onContactEdit}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* List Footer */}
      <div className="bg-slate-50 border-t border-slate-200 p-4">
        <div className="flex items-center justify-between text-sm text-slate-600">
          <span>Toplam {contacts?.length} kişi</span>
          <div className="flex items-center space-x-2">
            <span>Sayfa başına:</span>
            <select className="border border-slate-200 rounded px-2 py-1 text-sm">
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactList;